/**
 * Selector creator for determining if poll results should be displayed or not.
 *
 * @param {string} id - Id of the poll.
 * @returns {Function}
 */
export function shouldShowResults(id) {
    return function (state) {
        return Boolean(state['features/polls']?.polls[id].showResults);
    };
}
/**
 * Selector creator for polls.
 *
 * @param {string} pollId - Id of the poll to get.
 * @returns {Function}
 */
export function getPoll(pollId) {
    return function (state) {
        return state['features/polls'].polls[pollId];
    };
}
/**
 * Selector for calculating the number of unread poll messages.
 *
 * @param {IReduxState} state - The redux state.
 * @returns {number} The number of unread messages.
 */
export function getUnreadPollCount(state) {
    const { nbUnreadPolls } = state['features/polls'];
    return nbUnreadPolls;
}
/**
 * Determines if the submit poll answer button should be disabled.
 *
 * @param {Array<boolean>} checkBoxStates - The states of the checkboxes.
 * @returns {boolean}
 */
export function isSubmitAnswerDisabled(checkBoxStates) {
    return !checkBoxStates.find(checked => checked);
}
/**
 * Check if the input array has identical answers.
 *
 * @param {Array<IAnswerData>} currentAnswers - The array of current answers to compare.
 * @returns {boolean} - Returns true if the answers are identical.
 */
export function hasIdenticalAnswers(currentAnswers) {
    const nonEmptyCurrentAnswers = currentAnswers.filter((answer) => answer.name !== '');
    const currentAnswersSet = new Set(nonEmptyCurrentAnswers.map(answer => answer.name));
    return currentAnswersSet.size !== nonEmptyCurrentAnswers.length;
}
export const convertedObject = (data) => {
    return data.reduce((acc, value, index, array) => {
        if (index % 2 === 0) {
            // Even index: Use as key
            acc[value] = array[index + 1]; // Next item is the value
        }
        return acc;
    }, {});
};
